import { render, staticRenderFns } from "./SelectProductID.vue?vue&type=template&id=64554e57&"
import script from "./SelectProductID.vue?vue&type=script&lang=js&"
export * from "./SelectProductID.vue?vue&type=script&lang=js&"
import style0 from "./SelectProductID.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
